import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { GA_ID, GOOGLE_ADS_ID, LINKEDIN_PARTNER_ID } from "@/config/site";

const KEY = "airthermo-consent";
const MAX_AGE = 1000 * 60 * 60 * 24 * 180;

const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && Date.now() - c.at < MAX_AGE ? c : null;
  } catch { return null; }
};

const addScript = (src) => {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

// Charge les traceurs uniquement pour les catégories acceptées
const loadTrackers = ({ analytics, ads }) => {
  const gtagIds = [analytics && GA_ID, ads && GOOGLE_ADS_ID].filter(Boolean);
  if (gtagIds.length) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    gtagIds.forEach((id) => window.gtag("config", id));
    addScript(`https://www.googletagmanager.com/gtag/js?id=${gtagIds[0]}`);
  }
  if (ads && LINKEDIN_PARTNER_ID && !window._linkedin_data_partner_ids) {
    window._linkedin_data_partner_ids = [LINKEDIN_PARTNER_ID];
    addScript("https://snap.licdn.com/li.lms-analytics/insight.min.js");
  }
};

export const openCookieSettings = () => window.dispatchEvent(new Event("airthermo-cookies"));

export function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [choice, setChoice] = useState({ analytics: false, ads: false });
  useEffect(() => {
    const saved = readConsent();
    if (saved) { setChoice(saved); loadTrackers(saved); } else setOpen(true);
    const reopen = () => { setCustom(true); setOpen(true); };
    window.addEventListener("airthermo-cookies", reopen);
    return () => window.removeEventListener("airthermo-cookies", reopen);
  }, []);
  const save = (c) => {
    localStorage.setItem(KEY, JSON.stringify({ ...c, at: Date.now() }));
    setChoice(c); setOpen(false); setCustom(false); loadTrackers(c);
  };
  if (!open) return null;
  return (
    <div className="lp-cookies" role="dialog" aria-label="Gestion des cookies" data-testid="cookie-banner">
      <p><strong>Vos choix en matière de cookies</strong>Nous utilisons des cookies de mesure d'audience et de publicité uniquement avec votre accord. Vous pouvez changer d'avis à tout moment via « Gérer les cookies » en bas de page. <Link to="/politique-de-confidentialite" data-testid="cookie-privacy-link">En savoir plus</Link></p>
      {custom && (
        <div className="lp-cookies-opts" data-testid="cookie-options">
          <label><input type="checkbox" checked disabled />Nécessaires au fonctionnement du site (toujours actifs)</label>
          <label><input type="checkbox" checked={choice.analytics} onChange={(e) => setChoice({ ...choice, analytics: e.target.checked })} data-testid="cookie-analytics" />Mesure d'audience (Google Analytics)</label>
          <label><input type="checkbox" checked={choice.ads} onChange={(e) => setChoice({ ...choice, ads: e.target.checked })} data-testid="cookie-ads" />Publicité et suivi des campagnes (Google Ads, LinkedIn)</label>
        </div>
      )}
      <div className="lp-cookies-btns">
        <button type="button" onClick={() => save({ analytics: false, ads: false })} data-testid="cookie-refuse">Tout refuser</button>
        {custom
          ? <button type="button" onClick={() => save(choice)} data-testid="cookie-save">Enregistrer mes choix</button>
          : <button type="button" onClick={() => setCustom(true)} data-testid="cookie-customize">Personnaliser</button>}
        <button type="button" className="lp-cookies-ok" onClick={() => save({ analytics: true, ads: true })} data-testid="cookie-accept">Tout accepter</button>
      </div>
    </div>
  );
}
